import React from "react";
import DrawerNav from "../DrawerNav/DrawerNav";

const Dashboard = () => {
  return (
    <div>
      <DrawerNav />
    </div>
  );
};

export default Dashboard;
